export default __webpack_public_path__ + "static/media/con_chassis02.6ef62b72.jpg";